import { render, staticRenderFns } from "./TopicsPage.vue?vue&type=template&id=5ca44e28&scoped=true"
import script from "./TopicsPage.vue?vue&type=script&lang=js"
export * from "./TopicsPage.vue?vue&type=script&lang=js"
import style0 from "./TopicsPage.vue?vue&type=style&index=0&id=5ca44e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca44e28",
  null
  
)

export default component.exports